import style from './mad-id.module.scss';
import { MadIdState } from './mad-id.state';
import AccordionSection from './sections/accordion-section/accordion-section';
import FeaturesSection from './sections/features-section/feature-section';
import PreviewSection from './sections/preview-section/preview-section';
import ProblemSection from './sections/problem-section/problem-section';
import ProjectInfoSection from './sections/project-info-section/project-info-section';
import SolutionSection from './sections/solution-section/solution-section';
import BenefitsSection from './sections/benefits-section/benefits-section';
import QuoteSection from './sections/quote-section/quote-section';
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';

interface MadIdComponentProps {
  breadcrumbsText: string;
}

const MadIdComponent = ({ breadcrumbsText }: MadIdComponentProps) => {
  const {
    previewSection,
    projectInfoSection,
    problemSection,
    solutionSection,
    accordionSection,
    featuresSection,
    benefitsSection,
    quoteSection,
  } = MadIdState;
  return (
    <>
      <Breadcrumbs lastElementTitle={breadcrumbsText} />
      <div className={`${style.bnb__project}`}>
        <PreviewSection
          title={previewSection.title}
          subtitle={previewSection.subtitle}
          text={previewSection.text}
          image={previewSection.image}
        />
        <hr />
        <ProjectInfoSection title={projectInfoSection.title} list={projectInfoSection.list} />
        <hr />
        <ProblemSection title={problemSection.title} text={problemSection.text} />
        <hr />
        <SolutionSection text={solutionSection.text} title={solutionSection.title} />
        <hr />
        <AccordionSection
          title={accordionSection.title}
          subtitle={accordionSection.subtitle}
          accordion={accordionSection.accordion}
        />
        <hr />
        <FeaturesSection image={featuresSection.image} title={featuresSection.title} items={featuresSection.features} />

        <hr />
        <BenefitsSection
          title={benefitsSection.title}
          image={benefitsSection.image}
          benefits={benefitsSection.benefits}
        />
        <hr />
        <QuoteSection
          comment={quoteSection.comment}
          authorName={quoteSection.author.name}
          authorAvatar={quoteSection.author.avatar}
          authorSpecialist={quoteSection.author.specialist}
        />
      </div>
    </>
  );
};

export default MadIdComponent;
